import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'smoking'

const answers: AnswerType[] = [
  {
    emoji: '🚭',
    title: 'pages.onboarding.smoking.options.never',
    value: 'never',
  },
  {
    emoji: '🚬',
    title: 'pages.onboarding.smoking.options.oneToFive',
    value: '1-5',
  },
  {
    emoji: '🚬',
    title: 'pages.onboarding.smoking.options.occasionally',
    value: 'occasionally',
  },
  {
    emoji: '🔴',
    title: 'pages.onboarding.smoking.options.moreThanFive',
    value: 'more-than-5',
  },
]

export default function SmokingPage() {
  const [searchParams] = useSearchParams()
  const urlValue = searchParams.get('value')
  const preselectedValue =
    urlValue && answers.some((a) => a.value === urlValue) ? urlValue : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Do you smoke?',
      answer_key: answerValue,
      answer: answerValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.smoking.heading"
      preselectedValue={preselectedValue}
      onSubmit={onSubmit}
    />
  )
}
